module.exports = __webpack_public_path__ + "9bf2390537a732a45f56507afbe7330f.pdf";